import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { useCallRouter } from 'Modules/softphone/hooks';
import * as React from 'react';
import { Grid } from 'semantic-ui-react';

import type { RootStoreProps } from 'Stores/RootStore.types';
import { DirectoryRow } from './DirectoryRow';
import { DirectoryListItemProps } from './types';

export const DirectoryListItem: React.FC<DirectoryListItemProps> = observer(
  ({ contact, testid: parentTestId }) => {
    const testid = `${parentTestId}-directoryListItem`;
    const { conversation } =
      React.useContext<RootStoreProps>(MobXProviderContext);

    const { callWithPerson } = useCallRouter();

    const makeCall: (props: {
      type: 'userId' | 'phoneNumber';
      data: ContactModelV2;
    }) => void = ({ type, data }) => {
      if (type === 'userId' && data?.sourceId) {
        void callWithPerson(data.sourceId, undefined);
      }
      if (type === 'phoneNumber' && data?.mobileNumber) {
        void callWithPerson(undefined, data?.mobileNumber);
      }
    };

    const makeVideoCall = async () => {
      const response = await conversation.loadOrCreateConversationWithPost(
        contact.sourceId
      );
      void conversation.postConferenceByConversationId(
        response.data.id.toString()
      );
    };

    return (
      <Grid columns={4}>
        <DirectoryRow
          data={contact}
          makeCall={(type) => makeCall({ data: contact, type })}
          makeVideoCall={makeVideoCall}
          testid={testid}
        />
      </Grid>
    );
  }
);
